import React, { ReactElement } from 'react';
import { ListItem, ListItemText } from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

export interface IContentTableItemProps {
	name: string;
	showArrow?: boolean;
	selected?: boolean;
	onClick?: () => void;
}

export function ContentTableItem(
	props: IContentTableItemProps
): ReactElement {
	const { name, showArrow, selected, onClick } = props;

	return (
		<ListItem
			className="content-table-item"
			button
			selected={selected}
			onClick={onClick}
		>
			<ListItemText>{name}</ListItemText>
			{showArrow && <ArrowForwardIosIcon />}
		</ListItem>
	);
}
